import { render, staticRenderFns } from "./RealWorkExperience.vue?vue&type=template&id=a9a0d08a&"
import script from "./RealWorkExperience.vue?vue&type=script&lang=js&"
export * from "./RealWorkExperience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports